//Styles
import "./styles.scss";

//Images
import ratingMeter from "../../Assets/Svg/Auth/RatingMeter.svg";

function CardHero({
  headingName,
  approverName,
  assessorName,
  approvedOn,
  details,
  overallRating,
  wrap = false,
  rating,
}) {
  const capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <div className="card-hero">
      <div className="heading">
        <h2
          style={{
            maxWidth: `${wrap === true ? "80%" : "100%"}`,
            fontSize: "37px",
          }}
        >
          {wrap === true ? "Your Overall Score on the" : ""}{" "}
          {capitalizeWords(headingName)}
        </h2>
        {overallRating && (
          <div className="overall-rating">
            {/* <img
              src={ratingMeter}
              className="rating-meter"
              alt="ratingMeter"
              width="24"
              height="24"
            /> */}
            {overallRating}
          </div>
        )}
      </div>
      {(assessorName || approvedOn) && (
        <>
        <div className="details">
          <p>
            Assessor Name: &nbsp; <strong>{assessorName}</strong>
          </p>
          <p>
            Approved on: &nbsp;<strong>{approvedOn}</strong>
          </p>
        </div>
        <div className="details">
        <p>
          Approver Name: &nbsp; <strong>{approverName}</strong>
        </p>
        <p>
         
        </p>
      </div>
      </>
      )}
      <div>{details}</div>
      {rating && <div className="rating">{rating + "%"}</div>}
    </div>
  );
}

export default CardHero;
